module.exports = __webpack_public_path__ + "img/family-price.f9f7fbf8.png";